import { Link, useLocation } from "react-router";
import { Icon } from "@/components";
import { NAV_GROUPS, navItemFor } from "../navigation";
import styles from "./SidebarNav.module.css";

/** The grouped navigation list, used by the desktop sidebar and the small-screen drawer. */
export function SidebarNav({ onNavigate }: { onNavigate?: () => void }) {
  const location = useLocation();
  const active = navItemFor(location.pathname);
  return (
    <nav aria-label="Main" className={styles.nav}>
      {NAV_GROUPS.map((group) => (
        <section key={group.label} className={styles.group} aria-labelledby={`nav-${group.label}`}>
          <h2 id={`nav-${group.label}`} className={styles.groupLabel}>
            {group.label}
          </h2>
          <ul className={styles.list}>
            {group.items.map((item) => {
              const current = active?.item.to === item.to;
              return (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className={styles.link}
                    data-active={current ? "" : undefined}
                    aria-current={current ? "page" : undefined}
                    onClick={onNavigate}
                  >
                    <Icon name={item.icon} />
                    <span>{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </section>
      ))}
    </nav>
  );
}
